import React, { Component } from 'react';
import RecetteMensuelGrid from '../components/RecetteMensuelGrid';


class  RecetteMensuelle extends Component  {


  render() {
 
  
        return ( 
            
            <section className="services-section-four">

                <div className='auto-container'>
                  
                        
                        <RecetteMensuelGrid />
                   


                </div>

            </section>
        )
    }
  }

export default RecetteMensuelle 

